// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"31047cd1","769":"9cc22475"}[chunkId] + ".chunk.js";
};